// extracted by mini-css-extract-plugin
export var addToCartButton = "_q7-b";
export var arrowButtonContainer = "_q7-9";
export var arrowButtonIcon = "_q7-a";
export var carouselArrowButton = "_q7-6";
export var carouselElementContainer = "_q7-1";
export var left = "_q7-7";
export var productDisplayCarouselContainer = "_q7-0";
export var productTileContainer = "_q7-2";
export var productTileImage = "_q7-4";
export var productTileImageContainer = "_q7-3";
export var productTileTitle = "_q7-5";
export var right = "_q7-8";
export var sliderOverflow = "_q7-c";